import Vuex from 'vuex'
import Vue from 'vue'
import { rootStore } from '@/store/root/root.store'

Vue.use(Vuex)
export const store = new Vuex.Store(rootStore)
